// Importaciones de paquetes
import React, { useEffect, useMemo, useRef, useState } from "react";
import { MRT_ColumnDef } from "material-react-table";
// Importaciones de componentes
import { refresh_token } from "../../main_components/tokens/tokenrefreshNewMethod";
import { UPDATE_NULL_IDENTIFIERS } from "../../main_components/methods_v2/auxiliary_functions_new_method";
import { USER_ROL, RESPONSE } from "./interface/interface";
import MATERIAL_TABLE_CONTAINER from "../../main_components/material_table/table_container";
import GENERAL_FORM from "../../main_components/material_table/general_form";
import {
  updated_form_data,
  validate_data,
  processed_format,
} from "./tools/auxiliar_funtions";

import { create_object } from "./tools/auxiliar_funtions";
//IMG / ICONS

import CREATE from "../../imgComponents/create.png";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveAsIcon from "@mui/icons-material/SaveAs";

import { inf_partner } from "./tools/inf_users";

import { roles_users_get, roles_users_available_get } from "../../services/configuration/rol";

import { user_post, user_put, user_delete } from "../../services/configuration/rol";
import { modules_get } from "../../services/configuration/roles";
import { users_get } from "../../services/configuration/users";
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';


import { Box, Button } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import dayjs from "dayjs";
import { formattedCurrentDate, formattedPreviousDate } from "../../main_components/date/day";
import { supplier_invoices_get } from "../../services/expenses/expense";
import { supplier_invoice_details_get } from "../../services/expenses/purchase_orders";
import { supplier_invoices_post } from "../../services/expenses/expense";
import { paginatedApiCall } from "../../main_components/pagination/paginated_api_call";

import { supplier_invoices_delete } from "../../services/expenses/expense";
import { supplier_invoices_download } from "../../services/expenses/expense";
import { base64toBlobxml, base64toBlob } from "../../main_components/donwloadfuncion/download";

export interface FormData {
  id: number | string;
  username: string;
  fullusername: string;
  phone: string;
  email: string;
  job: string;
}


const SUPPLIER_INVOICE_TS: React.FC = () => {
  const [data, setData] = useState<USER_ROL[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [modalT, setmodalT] = useState<boolean>(false);
  const [loadingSkeleton, setLoadingSkeleton] = useState<boolean>(false);
  const [open_form, setopen_form] = useState(false);
  const [isNewEntry, setIsNewEntry] = useState(false);
  const [formData, setformData] = useState([]);
  const [methodDelete, setMethodDelete] = useState(false);
  const [identifier_data, setidentifier_data] = useState<any>(null);
  const [ff, setff] = useState(dayjs(formattedCurrentDate));
  const [fi, setfi] = useState(dayjs(formattedPreviousDate));
  const update_identifiers =
    [
      { invoice_date: 'string' },
      { serie: 'string' },
      { folio: 'string' },
      { name_business_partner: 'string' },
      { rfc_business_partner: 'string' },
      { subtotal: 'number' },
      { discount: 'number' },
      { tax: 'string' },
      { total: 'number' },
      { payment_method: 'string' },
      { forma_pago: 'string' },
      { tipodecomprobante: 'string' },
      { cancel: 'string' },
      { uuid_sat: 'string' },
      { username: 'string' }
    ];


  const handleAddCustomRoles = async (originalObj: any, isNew: boolean) => {
    try {


      console.log(originalObj)
      let details;
      const response_invoice = await supplier_invoice_details_get(originalObj?.id);

      details = response_invoice.data

      originalObj = {
        ...originalObj,
        details: details,
      };

      originalObj = {
        ...originalObj,
        details: { invoice: originalObj, rfc_business_partner: originalObj.rfc_business_partner },

      };
      // const responseInvoice = await supplier_invoices_post(originalObj);
      // const response = await staus_purchase_order_post(id, originalObj, { check_status_and_details: true });

      console.log(originalObj)
      setformData(originalObj)
      setIsNewEntry(isNew);
      setLoadingSkeleton(false)
      setMethodDelete(false);
    } catch (error) {
      console.error("Error al manejar add_address_bp:", error);
      return null;
    }
  };




  const handleAddUser = async (originalObj: any, isNew: boolean) => {
    try {
      setformData(originalObj)
      setIsNewEntry(isNew);
      setLoadingSkeleton(false)
      setMethodDelete(false);

    } catch (error) {
      console.error("Error al manejar add_address_bp:", error);
      return null;
    }
  };

  const handleOpenForm = (new_value: any, isNew: boolean) => {
    if (isNew) {
      setLoadingSkeleton(true)
      setopen_form(true);
      setMethodDelete(false);
      handleAddUser(new_value, isNew);
    } else {
      setopen_form(true);
      setLoadingSkeleton(true)
      setMethodDelete(false);
      handleAddCustomRoles(new_value, isNew);
    }
  };



  const handleClose = () => { setopen_form(false); };

  const procesarObjeto = (obj: any) => {
    const { rol, accountnonexpired, accountnonlocked, credentialsnonexpired, editable, failedattempts, id_company_fk, user_enable, id, ...resto } = obj;
    return {
      ...resto,
      roles: { modules: obj.rol?.custom_roles?.modules ?? [] }
    };
  };

  const handleSaveData = async (
    finalObject: any,
    method: any,
    identifier_data: any
  ) => {
    console.log("Datos a procesar:", procesarObjeto(finalObject));
    console.log("True / Post, False / Put, Delete:", method);

    setmodalT(true);

    try {
      switch (method) {
        case true:
          console.log("Creando objeto...");
          await user_post(procesarObjeto(finalObject));
          console.log("Objeto creado con éxito");
          handleSupplier();
          handleClose();
          break;

        case false:
          console.log("Actualizando objeto...");
          await user_put(procesarObjeto(finalObject), identifier_data);
          console.log("Objeto actualizado con éxito");
          handleSupplier();
          handleClose();
          break;



        case 'delete':
          console.log("Eliminando objeto...");
          await supplier_invoices_delete(identifier_data);
          console.log("Objeto actualizado con éxito");
          handleSupplier();
          handleClose();
          break;

        default:
          console.error("Método no reconocido");
      }
    } catch (error: any) {
      alert(error.response.data.errorMessage.es);
      console.error("Error al procesar los datos:", error);
    } finally {
      setmodalT(false);
      console.log("Operación finalizada.");
    }
  };

  const verifyToken = async (): Promise<boolean> => {
    try {
      return await refresh_token();
    } catch (error) {
      console.error("Error al verificar el token:", error);
      return false;
    }
  };

  const fetchRolesUsers = async (id: any) => {
    try {

      const response = await roles_users_get(id);
      return response.data.roles;
    } catch (error) {
      console.error("Error al obtener los datos de dirección:", error);
      return [];
    }
  };

  const fetchRolesUsersavailable = async (id: any) => {
    try {
      const response = await roles_users_available_get(id);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los datos del socio:", error);
      return [];
    }
  };
  const fetchUsers = async (): Promise<USER_ROL[]> => {
    try {
      // const rawResponse = await supplier_invoices_get(fi.format('YYYY-MM-DD'), ff.format('YYYY-MM-DD'));
      const rawResponse = await paginatedApiCall(3, "supplier_bp", { di: fi.format('YYYY-MM-DD'), df: ff.format('YYYY-MM-DD'), });

      const data = rawResponse;
      console.log(data);
      return UPDATE_NULL_IDENTIFIERS(
        data,
        update_identifiers
      ) as USER_ROL[];
    } catch (error) {
      console.error("Error al obtener los datos del usuario:", error);
      return [];
    }
  };

  const fetchModules = async () => {
    try {
      const response = await modules_get();
      return response.data;
    } catch (error) {
      console.error("Error al obtener el código del socio:", error);
      return [];
    }
  };


  const handleSupplier = async (event?: React.SyntheticEvent): Promise<void> => {
    event?.preventDefault();
    setIsLoading(true);
    setmodalT(true);
    setData([]);
    const isTokenValid = await verifyToken();
    if (!isTokenValid) {
      setIsLoading(true);
      setmodalT(true);
      console.error("Token inválido o expirado. Deteniendo el proceso...");
      console.log("Actualizando token...");
      setTimeout(() => {
        handleSupplier();
      }, 1000);
      return;
    }
    const data = await fetchUsers();
    setData(data);
    setIsLoading(false);
    setmodalT(false);
  };








  const handle_download_invoice = async (id: any, file_name: any, document_type: any) => {
    setmodalT(true);

    try {
      var data = await supplier_invoices_download(id, file_name, document_type);
      setmodalT(false);
      var dt = data.data.file;
      var blob;
      if (document_type === "xml") {
        blob = base64toBlobxml(dt);
      } else {
        blob = base64toBlob(dt);
      }
      const blobUrl = URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      var arr = file_name?.split("/");
      downloadLink.download = arr[4] + `.${document_type}`;
      downloadLink.click();
      setmodalT(false);
    } catch (err) {
      setmodalT(false);
    }
  };








  const columns: MRT_ColumnDef<any>[] = useMemo(
    () => [
      {
        id: "AC.",
        header: "AC.",
        size: 80,
        enableFilters: false,
        enableColumnFilters: false,
        enableColumnFiltering: false,
        enableEditing: false,
        enableColumnFilterModes: false,
        enableRowOrdering: false,
        enableGrouping: false,
        enableColumnDragging: false,
        enableColumnActions: false,
        accessorFn: (d) => {
          return (
            <div>
              <span
                style={{ display: d.related_order === true ? "none" : "" }}
                title="Relacionar Orden de Compra"
                onClick={() => {
                  console.log(d)
                  setMethodDelete(true);
                  handleOpenForm(d, false);
                  setidentifier_data(d.id);
                }}
              >
                <ContentPasteGoIcon className="icons_general_save"></ContentPasteGoIcon>
              </span>
              <span
                title="Descargar PDF"
                onClick={() => {
                  handle_download_invoice(d.id, d.filename, "pdf")
                }}
              >
                <PictureAsPdfIcon className="icons_general_delete"></PictureAsPdfIcon>
              </span>
              <span
                title="Descargar XML"
                onClick={() => {
                  handle_download_invoice(d.id, d.filename, "xml")
                }}
              >
                <IntegrationInstructionsIcon className="icons_general_save"></IntegrationInstructionsIcon>
              </span>

              <span
                title="Eliminar Factura"
                onClick={() => {
                  setMethodDelete(true);
                  setopen_form(true);
                  setidentifier_data(d?.id);
                }}
              >
                <DeleteIcon className="icons_general_delete"></DeleteIcon>
              </span>
              {/*  */}
            </div>
          );
        },
        muiTableHeaderCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },

      {
        id: "invoice_date",
        header: "Fecha",
        accessorKey: "invoice_date",
        size: 130,
        accessorFn: (row: any) => {
          const date = new Date(row.invoice_date);
          return (
            <span className="text-gray-700">
              {date.toLocaleString("es-MX")}
            </span>
          );
        },
      },

      {
        header: "Serie",
        accessorKey: "serie",
        id: "serie",
        size: 100,
      },
      {
        id: "folio",
        header: "Folio",
        accessorKey: "folio",
        size: 140,

      },
      {
        header: "Cliente",
        accessorKey: "name_business_partner",
        id: "name_business_partner"
      },
      {
        header: "RFC",
        accessorKey: "rfc_business_partner",
        id: "rfc_business_partner"
      },

      {
        id: "subtotal",
        header: "Subtotal",
        accessorKey: "subtotal",
        muiTableBodyCellProps: {
          align: 'right',
        },
        muiTableFooterCellProps: {
          align: 'right',
        },
        size: 140,
        accessorFn: (row: any) => {
          const total = parseFloat(row.total);
          const formatted = total.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
          return (
            <span className="text-green-600 font-bold">
              {formatted}
            </span>
          );
        },
      },
      {
        id: "discount",
        header: "Descuento",
        accessorKey: "discount",
        size: 110,
        muiTableBodyCellProps: {
          align: 'right',
        },
        muiTableFooterCellProps: {
          align: 'right',
        },
      },
      {
        id: "tax",
        header: "Impuesto",
        accessorKey: "tax",
        muiTableBodyCellProps: {
          align: 'right',
        },
        muiTableFooterCellProps: {
          align: 'right',
        },
        size: 140,
        accessorFn: (row: any) => {
          const total = parseFloat(row.total);
          const formatted = total.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
          return (
            <span className="text-green-600 font-bold">
              {formatted}
            </span>
          );
        },
      },
      {
        id: "total",
        header: "Total",
        accessorKey: "total",
        muiTableBodyCellProps: {
          align: 'right',
        },
        muiTableFooterCellProps: {
          align: 'right',
        },
        size: 140,
        accessorFn: (row: any) => {
          const total = parseFloat(row.total);
          const formatted = total.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
          return (
            <span className="text-green-600 font-bold">
              {formatted}
            </span>
          );
        },
      },

      {
        header: "Método de pago",
        accessorKey: "payment_method",
        id: "payment_method",
        filterVariant: 'multi-select',
      },
      {
        header: "Forma de Pago",
        accessorKey: "forma_pago",
        id: "forma_pago",
        filterVariant: 'multi-select',
      },
      {
        id: "tipodecomprobante",
        header: "Tipo de comprobante",
        accessorKey: "tipodecomprobante",
        filterVariant: 'multi-select',

      },
      {
        id: "cancel",
        header: "Estado",
        accessorKey: "cancel",
        accessorFn: (d: any) => {
          return d.cancel === true ? "CANCELADO" : "VIGENTE";
        },
      },
      {
        id: "uuid_sat",
        header: "UUID_SAT",
        accessorKey: "uuid_sat",
      },
      {
        header: "Usuario",
        accessorKey: "username",
        id: "username"
      },
    ],
    []
  );

  useEffect(() => {
    handleSupplier();
  }, []);



  return (
    <div style={{ width: "100%", margin: "0 auto" }} className="new_table_v2">
      <GENERAL_FORM
        open={open_form}
        onClose={handleClose}
        data_form={inf_partner}
        onSave={handleSaveData}
        isNew={isNewEntry}
        title_create="RELACIONAR FACTURA"
        title_update="RELACIONAR FACTURA"
        validateField={validate_data}
        handleProcessedFormat={processed_format}
        FormData={FormData}
        original_data={formData}
        size={methodDelete ? "30%" : "75%"}
        methodDelete={methodDelete}
        message_delete="¿Esta seguro de eliminar esta factura?"
        updatedFormData={updated_form_data}
        identifier_data={identifier_data}
        loadingSkeleton={loadingSkeleton}
      />


      <MATERIAL_TABLE_CONTAINER
        columns={columns}
        data={data}
        breadcrumbs={[{ label: "DOCUMENTOS ENVIADOS", path: null }]}
        modalT={modalT}
        isLoading={isLoading}
        search_filters={
          <div className="search-new-container2">
            <div className="div1cn2">

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{ width: "100%" }}
                  label="Fecha Inicial"
                  value={fi}
                  onChange={(newValue: any) => setfi(newValue)}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </div>
            <div className="div2cn2">

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{ width: "100%" }}
                  label="Fecha Final"
                  value={ff}
                  onChange={(newValue: any) => setff(newValue)}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>

            </div>

            <div className="div3cn2">

              <Button
                variant="contained"
                title='BUSCAR'
                sx={{ height: '35px', borderRadius: "15px", marginRight: "5px", width: "100%" }}
                onClick={(e) => {
                  handleSupplier()
                }}
              >
                <ManageSearchIcon></ManageSearchIcon>
              </Button>

            </div>
          </div>
        }
        component_header={
          <div></div>
        }
        file_name_export="Documentos enviados"
        update_identifiers={update_identifiers}
      ></MATERIAL_TABLE_CONTAINER>
    </div>
  );
};

export default SUPPLIER_INVOICE_TS;
